(function(){
  if (window.__jygIcast) return; window.__jygIcast = true;
  var root = document.documentElement; root.classList.add('js');
  function ready(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function(){
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var blocks = [].slice.call(document.querySelectorAll('.pb'));
    var items  = [].slice.call(document.querySelectorAll('.spec-item, .spec-m-item'));
    var rails  = [].slice.call(document.querySelectorAll('.spec-rail, .spec-rail-m'));
    var lineup = document.getElementById('jyg-lineup');

    // Reveal-in: one-shot IntersectionObserver, no per-scroll layout reads.
    if ('IntersectionObserver' in window && !reduce){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -15% 0px' });
      [].slice.call(document.querySelectorAll('.rvroot')).forEach(function(r){ io.observe(r); });
    } else {
      [].slice.call(document.querySelectorAll('.rvroot')).forEach(function(r){ r.classList.add('in'); });
    }

    // Active-product + rail visibility: rAF-throttled, one rect batch per frame.
    var ticking = false;
    function measure(){
      ticking = false;
      var vh = window.innerHeight;
      if (blocks.length){
        var best = -1, bd = 1e9;
        for (var i=0;i<blocks.length;i++){
          var r = blocks[i].getBoundingClientRect();
          var d = Math.abs(r.top + r.height/2 - vh/2);
          if (d < bd){ bd = d; best = i; }
        }
        if (best >= 0) items.forEach(function(it){ it.classList.toggle('active', String(it.getAttribute('data-idx')) === String(best)); });
      }
      if (lineup){ var lr = lineup.getBoundingClientRect(); var off = lr.bottom < vh * 0.4 || lr.top > vh * 0.9; rails.forEach(function(n){ n.classList.toggle('rail-off', off); }); }
    }
    function onScroll(){ if (!ticking){ ticking = true; requestAnimationFrame(measure); } }
    window.addEventListener('scroll', onScroll, { passive:true });
    window.addEventListener('resize', onScroll, { passive:true });
    window.addEventListener('load', onScroll);
    measure();

    [].slice.call(document.querySelectorAll('.jyg-form')).forEach(function(f){
      var input = f.querySelector('input[type=email]');
      f.addEventListener('submit', function(e){
        e.preventDefault();
        var ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((input.value || '').trim());
        if (ok){ var d = document.createElement('div'); d.className = 'form-done'; d.textContent = "You're on the list."; f.parentNode.replaceChild(d, f); }
        else { input.classList.add('bad'); }
      });
      if (input) input.addEventListener('input', function(){ this.classList.remove('bad'); });
    });
  });
})();